import { defaultEvaluation, Evaluation } from 'model/dealer/evaluation.model';
import { StandardReducerImpl, StandardState } from 'reducers/standard.reducer';

const entity = 'Evaluation';
const apiUrl = '/api/yumei-mall-train/visitRecord';
const standardReducerImpl = new StandardReducerImpl<Evaluation>(entity, defaultEvaluation, apiUrl);
export type EvaluationState = StandardState<Evaluation>;
export const evaluation = standardReducerImpl.buildStandardReducer();

export const getEntities = standardReducerImpl.getEntities;
export const getEntity = standardReducerImpl.getEntity;
export const createEntity = standardReducerImpl.createEntity;
export const updateEntity = standardReducerImpl.updateEntity;
export const deleteEntity = standardReducerImpl.deleteEntity;
export const reset = standardReducerImpl.reset;